module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAbCAYAAAD28DaZAAAAS0lEQVRIie3UMQ4AIRDDwIDu/19eBPW5T+F5gbWCrJmZlNgtIdeXZBV0PFWXMYYYQ+5vcmf+uDPEGGIMcfSIo0d8wMQY4s6QnsskOUY1Bz4doEisAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/菜单栏.png
// module id = HzBd
// module chunks = 14